import { ReactNode, useRef } from "react";
import useAppointmentFormContextLayout from "@/helper/customHooks/useAppointmentFormContextLayout";
import styles from "@/components/appointmentDashboard/appointmentTreeView.module.css";
import classNames from "classnames";

interface Props {
  toolbar: ReactNode;
  actions: ReactNode;
  details: ReactNode;
  expandedPanelCount: number;
  children: ReactNode;
}

export default function AppointmentFormLayout({ toolbar, actions, details, expandedPanelCount, children }: Props) {
  const layoutRef = useRef<HTMLDivElement>(null);
  const contextRef = useRef<HTMLDivElement>(null);
  const isPinned = useAppointmentFormContextLayout(layoutRef, contextRef, expandedPanelCount);

  return (
    <div ref={layoutRef} className={classNames(styles.formView, { [styles.formViewPinned]: isPinned })}>
      {toolbar}
      <div ref={contextRef} className={styles.formContext} data-testid="appointment-form-context">
        {actions}
        {details}
      </div>
      {children}
    </div>
  );
}
